// extracted by mini-css-extract-plugin
export default {"footer":"app_footer__8rBUW"};